export default __webpack_public_path__ + "static/media/busFrontNoCheckedIcon.e13f0cc1.svg";